export function copyObject<_T>(orgObj: _T): _T {
	return JSON.parse(JSON.stringify(orgObj)) as _T;
}
